import { render, staticRenderFns } from "./ShowDocsPupup.vue?vue&type=template&id=19e86793"
import script from "./ShowDocsPupup.vue?vue&type=script&lang=js"
export * from "./ShowDocsPupup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports